import React from "react"
import { auditShape } from "utils/propTypeShapes"

const FormSubmissionExportedAuditItemDetails = ({ audit }) => {
  const { comment } = audit
  const hasComment = comment

  return (
    <div>
      Exported submission{ hasComment ? ` (${comment}).` : "." }
    </div>
  )
}

FormSubmissionExportedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default FormSubmissionExportedAuditItemDetails
